// This file is reserved to build the future in.

// TODO: Insert next-gen SPA code in... angular?

import { IAngularStatic } from 'angular';

declare global {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface angular extends IAngularStatic {}
}

// The original curalate-libs.js
import 'curalate-libs';

// All 'must run first' code
import 'early';

// The original curalate-all.js
import 'curalate-all';

// All boilerplate app code
import 'app/curalate.app';

// Bootstrap angularjs
import bootstrapper from 'app/initialization/angular/angular-bootstrap';

bootstrapper();
